import React from 'react'
import { Circle } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const RadioButtonSelectedIcon = createIcon({
    viewBox: '0 0 20 20',
    path: (
        <>
            <Circle cx='10' cy='10' r='9' stroke='currentColor' strokeWidth='2' />
            <Circle cx='10' cy='10' r='6' fill='currentColor' />
        </>
    ),
})

RadioButtonSelectedIcon.displayName = 'RadioButtonSelectedIcon'
